module.exports = __webpack_public_path__ + "images/assets/7a62f613c2e36ce7435a58a6188d677c.svg";